import strings from 'strings';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';

export const COPIES = strings.sendoutsV2.drawers.tabs.emails;
export const PAGE_KEY = PERSISTENCE_KEYS.SENDOUTS.EMAILS;
export const EMAIL_DETAILS_RENDERER = 'emailDetails';

export const EMAILS_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'eventLabel',
    label: COPIES.columns.trigger,
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'sentDate',
    label: COPIES.columns.sentDate,
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'details',
    label: COPIES.columns.details,
    options: {
      sort: false,
      display: true,
      renderer: EMAIL_DETAILS_RENDERER
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'sentDate',
  direction: 'desc'
};
